import Image from 'global/Image';
import styled from 'styled-components';

const IconFrame = styled.div`
  background-color: #796fec;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  width: 12px;
  height: 12px;
`;

export default function LabelBroadcast() {
  return (
    <IconFrame>
      <Image
        src="/icon/broadcast.svg"
        width="8px"
        height="8px"
        alt="icon-broadcast"
      />
    </IconFrame>
  );
}
